<template>
    <div class="kt-portlet ml-md-3 ml-sm-0">
        <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
                <h6 class="kt-portlet__head-title">
                    Detalle vehículo personalizado
                </h6>
            </div>
        </div>
        <div class="col-12">
            <img :src="obj.dt7 ? uri + obj.dt7 : uri + obj.dt6" class="img-fluid"/>
        </div>
        <div class="col-12">
            <div class="m-1 pb-3">
                <div>
                    <h5 class="text-capitalize" >{{obj.dt4 | minusculas}} {{obj.ndt4}}</h5>
                    <h6 class="text-capitalize text-muted">{{obj.dt8 | minusculas}}</h6>
                </div>
                <table class="table-sm col">
                    <tbody>
                    <template v-for="(item,index) in lista">
                      <tr :key="index" class="bg-secondary" v-b-toggle="'collapse-'+obj.id+'-'+index">
                        <td>
                          <h6 class="p-2">{{ item.label }}</h6>
                        </td>
                        <td>
                          <h6 class="p-2 text-right precio-syb">{{ sumaItems(item) | puntos }}</h6>
                        </td>
                      </tr>
                      <b-collapse :id="'collapse-'+obj.id+'-'+index" :key="index+'col'" tag="tr" style="width: 100%;">
                        <td v-if="item.array" colspan="2" style="width: inherit" class="p-0 m-0">
                          <tr v-for="(subItem,subIndex) in obj[item.array]" :key="subIndex+'-'+index" style="width: inherit;display: table">
                            <td>
                              <h6 class="p-2">{{ subItem[item.dtoDetail] }}</h6>
                            </td>
                            <td>
                              <h6 class="p-2 text-right precio-syb">{{ subItem[item.dtoNumber] | puntos }}</h6>
                            </td>
                          </tr>
                        </td>
                        <template v-else>
                          <td>
                            <h6 class="p-2">{{ obj[item.dtoDetail] }}</h6>
                          </td>
                          <td>
                            <h6 class="p-2 text-right precio-syb">{{ obj[item.dtoNumber] | puntos }}</h6>
                          </td>
                        </template>
                      </b-collapse>
                    </template>
                    <tr class="bg-dark">
                      <td>
                        <h6 class="p-2 text-white label-table">
                          <b>Precio total del vehículo</b>
                        </h6>
                      </td>
                      <td>
                        <h6 class="p-2 text-white label-table text-right precio-syb">
                          <b>{{ obj.ndt3 | puntos }}</b>
                        </h6>
                      </td>
                    </tr>
                    <tr class="bg-primary" v-if="mostrar">
                      <td>
                        <h6 class="p-2 text-white label-table">
                          <b>Saldo</b>
                        </h6>
                      </td>
                      <td>
                        <h6 class="p-2 text-white label-table text-right precio-syb">
                          <b>{{ saldo | puntos }}</b>
                        </h6>
                      </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import constantes from "../constantes";
    export default {
        name: "resumen-vertical-online",
        data:()=>({
            uri:process.env.VUE_APP_URL_API,
          lista:[
            {
              label: "Paquetes",
              array: null,
              dtoNumber: "ndt8",
              dtoDetail: "dt1",
            },
            {
              label: "Accesorios individuales",
              array: 'elements',
              dtoNumber: "ndt1",
              dtoDetail: "dt1",
            },
            {
              label: "Kit de accesorios",
              array: 'elements2',
              dtoNumber: "ndt1",
              dtoDetail: "dt1",
            },
            {
              label: "Mantenimientos prepagados",
              array: 'elements3',
              dtoNumber: "ndt1",
              dtoDetail: "dt1",
            },
          ]
        }),
        computed:{
            obj:function(){
                return this.$store.getters.getCotizacion
            },
            saldo:function(){
                return (this.$store.getters.getCotizacion.ndt13);
            },
            mostrar:function(){
                return (this.$store.getters.getCotizacion.ndt3 - this.$store.getters.getCotizacion.ndt13).toFixed(2)>=0.01 && (this.$store.getters.getCotizacion.ndt3 - this.$store.getters.getCotizacion.ndt13)<this.$store.getters.getCotizacion.ndt3;
            }
        },
      filters:{
        minusculas:(dato)=>constantes.funciones.minusculas(dato),
        puntos:(numero)=>constantes.funciones.puntoMilesDecimal(numero),
      },
        methods:{
            suma:(vector)=>constantes.funciones.sumar(vector),
            suma2:(vector1,vector2)=>constantes.funciones.sumar2(vector1,vector2),
          suma3: (key, vector) => constantes.funciones.sumar3(key, vector),
          sumaItems:function(item){
            let suma = 0;
            if(item.array){
              suma+=this.suma3(item.dtoNumber,this.obj[item.array])
            }else{
              suma+=this.obj[item.dtoNumber];
            }
            return suma;
          },
        }
    }
</script>

<style scoped>

h3>span{
  display: block;
  font-size: x-small;
}
td>h6{
  margin: 0;
}
.bg-secondary{
  cursor: pointer;
}
tr.bg-secondary td:first-child h6:before{
  content: " ";
  transition: all .3s ease;
  font-family: "Font Awesome 5 Free",serif;
  font-style: normal;
  font-weight: 900;
  font-variant: normal;
  line-height: 1;
  text-decoration: inherit;
  text-rendering: optimizeLegibility;
  text-transform: none;
}
tr.collapsed td:first-child h6:before{
  content: " ";
  transition: all .3s ease;
  font-family: "Font Awesome 5 Free",serif;
  font-style: normal;
  font-weight: 900;
  font-variant: normal;
  line-height: 1;
  text-decoration: inherit;
  text-rendering: optimizeLegibility;
  text-transform: none;
}
</style>
